import React, { useContext } from "react";
import loadable from "@loadable/component";
import clsx from "clsx";
import PageContext from "@PageContext";
import WebProfileContext from "@WebProfileContext";
import useLocals from "@micado-digital/react-ui/hooks/useLocals";
import localDE from "@localDE";
import localEN from "@localEN";
import localNL from "@localNL";

import styles from "./Contact.styles";

const ReactLink = loadable(() => import("@micado-digital/react-link/ReactLink"));
const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));
const Typography = loadable(() => import("@micado-digital/react-ui/components/Typography"));
const SocialIcons = loadable(() => import("../../SocialIcons"));

const Contact = () => {
	const [pageData] = useContext(PageContext);
	let { lang } = pageData;
	const [profileData] = useContext(WebProfileContext);
	const { addition, city, links, mail, name, phone, phonePrivate, street, zip } = profileData;
	const css = styles();
	const l = useLocals({
		lang: lang,
		res: {
			de: localDE,
			en: localEN,
			nl: localNL
		}
	});

	return (
		<div className={clsx(css.contact, "mco-view-component-footer-contact")}>
			{name && (
				<Typography
					className={clsx(css.name, "mco-view-component-footer-contact__name")}
					variant="headline-small"
				>
					{name}
				</Typography>
			)}
			{addition && (
				<Typography
					className={clsx(css.addition, "mco-view-component-footer-contact__addition")}
					variant="body-medium"
				>
					{addition}
				</Typography>
			)}
			{street && (
				<Typography
					className={clsx(css.street, "mco-view-component-footer-contact__street")}
					variant="body-medium"
				>
					{street}
				</Typography>
			)}
			{city && (
				<Typography
					className={clsx(css.city, "mco-view-component-footer-contact__city")}
					variant="body-medium"
				>
					{zip ? `${zip} ${city}` : city}
				</Typography>
			)}
			{phone && (
				<div className={clsx(css.phone, "mco-view-component-footer-contact__phone")}>
					<a
						className={clsx(css.link, "mco-view-component-footer-contact__link")}
						href={`tel:${phone?.replace(/ /g, "")}`}
					>
						<ReactSVGIcon
							className={clsx(css.icon, "mco-view-component-footer-contact__icon")}
							src="/img/icons/phone.svg"
							size={20}
						/>
						<Typography variants={{ xs: "title-medium", md: "title-large" }}>
							{phone} (Office)
							{/* <Typography className={css.linkAddition} component="span" variant="label-small">
								{l("footer.phoneManagement")}
							</Typography> */}
						</Typography>
					</a>
				</div>
			)}
			{phonePrivate && (
				<div className={clsx(css.phonePrivate, "mco-view-component-footer-contact__phone")}>
					<a
						className={clsx(css.link, "mco-view-component-footer-contact__link")}
						href={`tel:${phonePrivate?.replace(/ /g, "")}`}
					>
						<ReactSVGIcon
							className={clsx(css.icon, "mco-view-component-footer-contact__icon")}
							src="/img/icons/phone.svg"
							size={20}
						/>
						<Typography variants={{ xs: "title-medium", md: "title-large" }}>
							{phonePrivate} (Restaurant Slow Down)
							{/* <Typography className={css.linkAddition} component="span" variant="label-small">
								{l("footer.phoneAssistant")}
							</Typography> */}
						</Typography>
					</a>
				</div>
			)}
			{mail && (
				<div className={clsx(css.mail, "mco-view-component-footer-contact__mail")}>
					<a
						className={clsx(css.link, "mco-view-component-footer-contact__link")}
						href={`mailto:${mail}`}
					>
						<ReactSVGIcon
							className={clsx(css.icon, "mco-view-component-footer-contact__icon")}
							src="/img/icons/mail.svg"
							size={20}
						/>
						<Typography variants={{ xs: "title-medium", md: "title-large" }}>
							{mail}
						</Typography>
					</a>
				</div>
			)}
			{links
				?.filter(item => item?.type === "whatsapp")
				.map((filteredItem, counter) => {
					return (
						<div
							className={clsx(css.whatsapp, "mco-view-component-footer-contact__whatsapp")}
							key={counter}
						>
							<ReactLink
								className={clsx(css.link, "mco-view-component-footer-contact__link")}
								rel="noopener noreferrer"
								target="_blank"
								title={filteredItem?.title}
								to={filteredItem?.url}
							>
								<ReactSVGIcon
									className={clsx(css.icon, "mco-view-component-footer-contact__icon")}
									size={20}
									src="/img/icons/whatsapp.svg"
								/>
								<Typography variants={{ xs: "title-medium", md: "title-large" }}>
									{filteredItem?.title}
								</Typography>
							</ReactLink>
						</div>
					);
				})}

			<div className={css.socialIcons}>
				<Typography className={css.socialIconsTitle} variant="label-medium">
					{l("footer.followUs")}
				</Typography>
				<SocialIcons />
			</div>
		</div>
	);
};

export default Contact;
